export default "__VITE_ASSET__acef65b5__"